import { Reducer } from 'redux';
import { IShowSnackbarState, IShowSnackbarAction } from './types';

const initialState = {
  snackbar: undefined
}

const ShowSnackbarReducer: Reducer<IShowSnackbarState> = ((state:IShowSnackbarState = initialState, action) => {
  switch((action as IShowSnackbarAction).type) {
    case "SHOW_SNACKBAR": {
      return { ...state, snackbar: action.snackbar}
    }
    default:
      return state
  }
});

export default ShowSnackbarReducer;
